import axios, { isAxiosError } from 'axios'

import { HttpCode } from 'common/http'
import {
  AlertingActionGetResponse,
  AlertingMetricsGetResponse,
  AlertingPolicyCreateRequest,
  AlertingPolicyGetResponse,
  CompleteAlertingIncidentActionParams,
  IncidentTimelineSearchRequest,
  IncidentTimelineSearchResponse,
  SkipAlertingIncidentActionParams,
  SlackUserGroup,
  UUID,
} from 'modules/Monitoring/types'

import { GetAlertingPoliciesParams } from './types'

export const getAlertingPolicies = async (params: GetAlertingPoliciesParams) => {
  // we use this endpoint to check the policy existence,
  // thus we don't want to alert 404 error
  try {
    const response = await axios.get<AlertingPolicyGetResponse>('/alerting/policies', {
      params,
    })

    return response.data
  } catch (error: unknown) {
    if (
      isAxiosError(error) &&
      error.response &&
      error.response.status === HttpCode.NotFound
    ) {
      return null
    }

    throw error
  }
}
export const getAlertingMetrics = async (params: GetAlertingPoliciesParams) => {
  return (await axios.get<AlertingMetricsGetResponse>('/alerting/metrics', { params }))
    .data
}
export const getAlertingSlackUserGroups = async () => {
  return (await axios.get<SlackUserGroup[]>('/alerting/slack/user-groups')).data
}
export const getAlertingIncidentsTimelines = async (
  body: IncidentTimelineSearchRequest,
) => {
  return (
    await axios.post<IncidentTimelineSearchResponse>(
      '/alerting/incidents/timelines/search',
      body,
    )
  ).data
}
export const getAlertingActions = async () => {
  return (await axios.get<AlertingActionGetResponse>('/alerting/actions')).data
}

export const createAlertingPolicy = async (body: AlertingPolicyCreateRequest) => {
  return (await axios.post('/alerting/policies', body)).data
}
export const deleteAlertingPolicy = async (alertingPolicyId: UUID) => {
  return (await axios.delete(`/alerting/policies/${alertingPolicyId}`)).data
}
export const refreshAlertingSlackUserGroups = async () => {
  return (await axios.post('/alerting/slack/user-groups/refresh')).data
}
export const closeAlertingIncident = async (incidentId: UUID) => {
  return (await axios.post(`/alerting/incidents/${incidentId}/close`)).data
}
export const acknowledgeAlertingIncident = async (incidentId: UUID) => {
  return (await axios.post(`/alerting/incidents/${incidentId}/acknowledge`)).data
}
export const completeAlertingIncidentAction = async ({
  incidentActionId,
  body,
}: CompleteAlertingIncidentActionParams) => {
  return (
    await axios.post(`/alerting/incidents/action/${incidentActionId}/complete`, body)
  ).data
}
export const skipAlertingIncidentAction = async ({
  incidentActionId,
  body,
}: SkipAlertingIncidentActionParams) => {
  return (await axios.post(`/alerting/incidents/action/${incidentActionId}/skip`, body))
    .data
}
